export function abbreviateNumber(params: { value: number }): string {
  const { value } = params

  const mil = 1000
  const million = 1000000

  const toStringDecimal = (params: { from: number; limit: number }) => {
    const { from, limit } = params

    const parse = from / limit

    const split = parse.toString().split('.')

    const result = split[1] ? `${split[0]}.${split[1][0]}` : split[0]

    const toNumber = parseFloat(result) // delete decimal if is 0
    return toNumber.toString()
  }

  if (Math.abs(value) >= million) {
    const result = toStringDecimal({
      from: value,
      limit: million,
    })
    return `${result}M`
  } else if (Math.abs(value) >= mil) {
    const result = toStringDecimal({
      from: value,
      limit: mil,
    })
    return `${result}K`
  } else {
    return value ? value.toString() : '  -'
  }
}

export const numberWithCommaWithoutDecimals = (
  value: any,
  withSymbol?: boolean
) => {
  const parse = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })?.format(value)

  if (parse.includes('NaN')) {
    return `${withSymbol ? '$ ' : ''}${0}`
  }

  const result = parse.replace('$', '')

  return `${withSymbol ? '$ ' : ''}${result}`
}

export function numberAsPercentage(number = 0, decimalPlaces = 2) {
  return `${(number * 100).toFixed(decimalPlaces)}%`
}
